/* Jeden záznam slovníku „pojem → ikona".
 *
 *   ikona  — React komponenta (lucide nebo doplněk z components/ikony/doplnky.js)
 *   ton    — jméno tónu z lib/ikony/tony.js (barva kategorie), NIKDY hex
 *   pojem  — co ikona ZNAMENÁ, napříč slovníky. Stejný pojem = stejná ikona
 *            všude (rezerva jako cíl i jako produkt), jiný pojem = jiná ikona.
 *            Hlídá __tests__/ikonySlovniky.test.js.
 *   klic   — klíč popisku ve slovníku překladů (5 jazyků), blok `ikony`
 *
 * Text nikdy nenese ikonu a ikona nikdy nenese text: popisek jde přes t(klic).
 */
export function zaznam(ikona, ton, pojem, klic) {
  return Object.freeze({ ikona, ton, pojem, klic });
}

/** Vybere záznam podle klíče, jinak záložní. Nikdy nevrací undefined. */
export function vyber(slovnik, klic, zalozni) {
  const k = klic == null ? "" : String(klic);
  return Object.prototype.hasOwnProperty.call(slovnik, k) ? slovnik[k] : slovnik[zalozni];
}
